import React from 'react';
import { useMediaQuery as useMediaQueryLib } from 'react-responsive';
import screens from '@repo/ui/src/utils/screens';

export const useMediaQuery = (mediaQuery: string) => {
  const [isScreenSize, setIsScreenSize] = React.useState(false);
  const hasDeviceSizeChanged = useMediaQueryLib({ query: mediaQuery });

  React.useEffect(() => {
    setIsScreenSize(hasDeviceSizeChanged);
  }, [hasDeviceSizeChanged]);

  return isScreenSize;
};

export const useReducedMotion = () => useMediaQuery(`(prefers-reduced-motion:reduce)`);
export const useIsMobile = () => useMediaQuery(`(max-width:${screens.sm})`);
export const useIsSM = () => useMediaQuery(`(min-width: ${screens.sm})`);
export const useIsMD = () => useMediaQuery(`(min-width: ${screens.md})`);
export const useIsLG = () => useMediaQuery(`(min-width: ${screens.lg})`);
export const useIsXL = () => useMediaQuery(`(min-width: ${screens.xl})`);
